import { accAdd, accMul, compare } from '../assets/js/util.js'
// 0005 是否刷新页面
export const reload_page = state => {
  return state.common.reload_page
}
// app端是否处理0005
export const handleTokenError = state => {
  if (state.duduApp.os === '1' || state.duduApp.os === '2') {
    if (state.duduApp.os === '1') {
      return compare(state.duduApp.app_version, '5.1.4') >= 0
    } else {
      return state.duduApp.app_version >= 51
    }
  } else {
    return true
  }
}

// 是否登录
export const is_login = state => {
  return state.userInfo.user_phone
  // return true
}
// 是否在app内
export const is_app = state => {
  if (state.duduApp.os === '1' || state.duduApp.os === '2') {
    return true
  }
}
export const os = state => {
  return state.duduApp.os
}
// 是否可以调用app端跳转 我的优惠券
export const show_jump_coupons_btn = state => {
  if (state.duduApp.os === '1' || state.duduApp.os === '2') {
    if (state.duduApp.os === '1') {
      return compare(state.duduApp.app_version, '5.1.1') > 0
    } else {
      return state.duduApp.app_version > 47
    }
  } else {
    return true
  }
}
// 是否微信端
export const is_weixin_browser = state => {
  return state.common.is_weixin_browser
}
// 是否ios
export const isiOS = state => {
  return state.common.isiOS
}

// 是否ios
export const is_android = state => {
  return state.common.is_android
}
// 所有费用明细配置
export const fee_config = state => {
  return state.order.fee_config
}

// 是否调用 App 七鱼
export const show_app_qiyu = state => {
  var _show = false
  if (state.duduApp.os === '1' || (state.duduApp.os === '2') && Number(state.duduApp.app_version) > 46) {
    _show = true
  }
  return _show
}

// 是否显示七鱼
export const show_qiyu = state => {
  var _show = true
  if (state.duduApp.os === '2' && Number(state.duduApp.app_version) < 47) {
    _show = false
  }
  return _show
}

export const innerHeight = state => {
  return window.innerHeight
}

export const user_phone = state => {
  if (state.userInfo && state.userInfo.user_phone) {
    var _phone = String(state.userInfo.user_phone)
    return _phone.substring(0, 3) + '****' + _phone.substring(7)
  } else {
    return null
  }
}

export const user_real_phone = state => {
  return state.userInfo.user_phone
}

// 订单出发时间
export const start_time = state => {
  return state.order.start_time
}

// 订单返回时间
export const end_time = state => {
  return state.order.end_time
}

// 默认订单出发时间
export const default_start_time = state => {
  var _time
  if (state.order.start_time) {
    _time = new Date(state.order.start_time.param)
  } else {
    var now_date = Date.parse(new Date()) // 现在时间
    var tomorrow_date = now_date + 86410000 + 300000 // 加多5min
    _time = new Date(tomorrow_date)
  }
  return _time
}

// 默认订单结束时间
export const default_end_time = state => {
  var _time
  if (state.order.end_time) {
    _time = new Date(state.order.end_time.param)
  } else {
    var now_date = Date.parse(new Date()) // 现在时间
    var tomorrow_date = now_date + 86410000 + 300000 // 加多5min
    _time = new Date(tomorrow_date)
  }
  return _time
}

// 订单类型
export const order_type = state => {
  return state.order.type
}

// 商务用车类型
export const order_business_type = state => {
  return state.order.business_type
}

// 深港互通类型
export const order_szhk_type = state => {
  return state.order.szhk_type
}

// 商务用车出发地
export const start_address = state => {
  return state.location.start_address
}

// 当前选中开放城市
export const select_open_city = state => {
  return state.location.select_open_city || state.location.current_city
}

// 当前定位城市
export const current_city = state => {
  return state.location.current_city
}

// 商务用车 包天出发地城市
export const start_address_city = state => {
  var _city = state.location.start_info ? state.location.start_info.split('-')[1] : null
  return _city
}

// 商务用车 包天出发地省份
export const start_address_province = state => {
  var _province = state.location.start_info ? state.location.start_info.split('-')[0] : null
  return _province
}

// 商务用车目的地
export const end_address = state => {
  return state.location.end_address
}

// 商务用车 包天目的地城市
export const end_address_city = state => {
  var _city = state.location.end_info ? state.location.end_info.split('-')[1] : null
  return _city
}

// 商务用车 包天目的地省份
export const end_address_province = state => {
  var _province = state.location.end_info ? state.location.end_info.split('-')[0] : null
  return _province
}

// 商务用车途径点
export const way_address = state => {
  return state.location.way_address
}

// 商务用车是否可提交 往返
export const if_submit_round = state => {
  var can_submit = false
  if (state.order.start_time && state.order.end_time && state.location.end_address && state.location.start_address) {
    can_submit = true
  }
  return can_submit
}
// 商务用车是否可提交 单程
export const if_submit_single = state => {
  var can_submit = false
  if (state.order.start_time && state.location.end_address && state.location.start_address) {
    can_submit = true
  }
  return can_submit
}

// 是否可提交 包天
export const if_submit_day = state => {
  var can_submit = false
  if (state.order.start_time && state.order.end_time && state.location.end_address && state.location.start_address) {
    can_submit = true
  }
  return can_submit
}

// 深港用车出发地
export const szhk_start_address = state => {
  return state.location.szhk_start_address
}

// 深港用车途径点
export const szhk_way_address = state => {
  return state.location.szhk_way_address
}

// 深港用车目的地
export const szhk_end_address = state => {
  return state.location.szhk_end_address
}

// 深港用车是否可提交 往返
export const if_szhk_submit_round = state => {
  var can_submit = false
  if (state.order.start_time && state.order.end_time && state.location.szhk_end_address && state.location.szhk_start_address) {
    can_submit = true
  }
  return can_submit
}

// 深港用车是否可提交 单程
export const if_szhk_submit_single = state => {
  var can_submit = false
  if (state.order.start_time && state.location.szhk_end_address && state.location.szhk_start_address) {
    can_submit = true
  }
  return can_submit
}

export const banner_list = state => {
  return state.common.banner_list
}

// 巴士列表
export const bus_list = state => {
  if (state.order.bus_list.length) {
    for (var i = 0, len = state.order.bus_list.length; i < len; i++) {
      var _bus = state.order.bus_list[i]
      if (_bus.seat_num <= 19) {
        _bus.className = 'icon_new_bus_19'
      } else if (_bus.seat_num <= 27) {
        _bus.className = 'icon_new_bus_27'
      } else if (_bus.seat_num <= 37) {
        _bus.className = 'icon_new_bus_37'
      } else {
        _bus.className = 'icon_new_bus_55'
      }
    }
    return state.order.bus_list
  } else {
    return []
  }
}

// 当前巴士
export const current_bus = state => {
  return state.order.current_bus
}

// 当前巴士一辆的信息
export const current_bus_info = state => {
  return state.order.current_bus_info
}

// 当前已选的巴士列表
export const selected_bus_list = state => {
  return state.order.bus_bill
}

// 当前巴士已选多少辆
export const current_bus_selected_num = state => {
  var _num = 0
  for (var i = 0, len = state.order.bus_bill.length; i < len; i++) {
    if (state.order.bus_bill[i].car_type_id === state.order.current_bus.car_type_id) {
      _num = state.order.bus_bill[i].bus_num
      break
    }
  }
  return _num
}

// 已选择车辆总共的座位
export const bus_bill_seat = state => {
  var _num = 0
  for (var i = 0, len = state.order.bus_bill.length; i < len; i++) {
    _num += (state.order.bus_bill[i].bus_num * state.order.bus_bill[i].seat_num)
  }
  return _num
}

// 已选择车辆总共的座位及行李
export const bus_bill_seat_bag = state => {
  var _bag = 0
  var _num = 0
  var _busNum = 0
  for (var i = 0, len = state.order.bus_bill.length; i < len; i++) {
    _num += (state.order.bus_bill[i].bus_num * state.order.bus_bill[i].seat_num)
    _bag += (state.order.bus_bill[i].bus_num * state.order.bus_bill[i].baggage_num)
    _busNum += state.order.bus_bill[i].bus_num
  }
  return {
    seat: _num,
    bag: _bag,
    bus_num: _busNum
  }
}

// 还需支付金额
export const bus_total_price = state => {
  var _count = 0
  for (var i = 0, len = state.order.bus_bill.length; i < len; i++) {
    var _item = state.order.bus_bill[i]
    if (_item.price) {
      var _bus_price = accMul(_item.price, _item.bus_num)
      _count = accAdd(_count, _bus_price)
    }
  }
  return _count
}

export const open_city_list = state => {
  return state.order.open_city_list
}

export const open_city_list_format = state => {
  return state.order.open_city_list_format
}

// 获取选择的优惠券
export const select_coupon = state => {
  return {
    money: state.myCoupon.select_money,
    id: state.myCoupon.select_id
  }
}

// 发票信息
export const invoice_info = state => {
  return state.order.invoice_info
}

export const szhk_start_city = state => {
  return state.location.hk_start ? '香港' : '广东'
}

export const szhk_end_city = state => {
  return state.location.hk_start ? '广东' : '香港'
}

// 两地的距离及用时
export const line_distance = state => {
  return state.location.line_distance
}

// 判断行程是否经过香港
export const include_hk = state => {
  var _include = false
  if (state.order.type !== 'business') {
    _include = true
  } else {
    var _start_city = state.location.start_info ? state.location.start_info.split('-')[1] : ''
    var _end_city = state.location.end_info ? state.location.end_info.split('-')[1] : ''
    if (_start_city.indexOf('香港') === 0 || _end_city.indexOf('香港') === 0) {
      _include = true
    }
    if (!_include) {
      for (var i = 0, len = state.location.way_address.length; i < len; i++) {
        var _place = state.location.way_address[i]
        if (_place.city && _place.city.indexOf('香港') === 0) {
          _include = true
          break
        }
      }
    }
  }
  return _include
}

export const qiyu_group_id = state => {
  return state.common.qiyu_group_id
}

export const qiyu_staff_id = state => {
  return state.common.qiyu_staff_id
}

// 提示添加途径点提示
export const tips_add_site = state => {
  return state.common.tips_add_site
}

// 企业id
export const enterprise_id = state => {
  return state.common.enterprise_id
}

export const enterprise_server_phone = state => {
  var phone = ''
  var id = state.common.enterprise_id + ''
  if (id === '199') {
    phone = '13549267470'
  } else if (id === '398') {
    phone = '18955329596'
  } else if (id === '498') {
    phone = '02968916001'
  }
  return phone
}

// const timeFormat = function (date, fmt) {
//   var o = {
//     'M+': date.getMonth() + 1, // 月份
//     'd+': date.getDate(), // 日
//     'h+': date.getHours(), // 小时
//     'm+': date.getMinutes(), // 分
//     's+': date.getSeconds(), // 秒
//     'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
//     'S': date.getMilliseconds() // 毫秒
//   }
//   if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
//   for (var k in o) {
//     if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
//   }
//   return fmt
// }

// const transformDate = date => {
//   var date_obj = {
//     cn_date: date.getMonth() + 1 + '月' + date.getDate() + '日',
//     time: date.getHours() + ':' + date.getMinutes(),
//     week: '周' + '日一二三四五六'.split('')[date.getDay()],
//     param: timeFormat(date, 'yyyy-MM-dd hh:mm'),
//     date: timeFormat(date, 'yyyy/MM/dd')
//   }
//   return date_obj
// }
// export const next_sixty_date = state => {
//   var _now_date = Date.parse(_now_date)
//   var _date_arr = []
//   for (var i = 1; i <= 60; i++) {
//     var _cal_date = transformDate(Date(_now_date + 86400000 * i))
//     console.log(_cal_date)
//     _date_arr.push(_cal_date)
//   }
//   return _date_arr
// }



// WEBPACK FOOTER //
// ./src/store/getters.js